const Version = {
  name: "v1.5.3",
};

export default Version;